import Config from '../../utils/Config';
import StateButton from '../StateButton';

export default class PlayButton extends Phaser.Group {
    constructor(game)
    {
        super(game);

        this.onAction = new Phaser.Signal();

        let playButton = this._playButton = new StateButton(game, 0, 0, 'buttons.play', this._onClickPlay, this);
        playButton.anchor.set(0.5);
        playButton.hitArea = null;
        this.addChild(playButton);

        let pauseButton = this._pauseButton = new StateButton(game, 0, 0, 'buttons.pause', this._onClickPause, this);
        pauseButton.anchor.set(0.5);
        pauseButton.hitArea = null;
        this.addChild(pauseButton);

        this.unlock();
    }

    enablePlayButton()
    {
        this._playButton.enabled = true;
        this._playButton.visible = true;
        this._pauseButton.visible = !this._playButton.visible;
    }

    enablePauseButton()
    {
        this._pauseButton.enabled = true;
        this._pauseButton.visible = true;
        this._playButton.visible = !this._pauseButton.visible;
    }

    lock(canPause = false)
    {
        this._playButton.visible = !canPause;
        this._pauseButton.visible = !this._playButton.visible;

        this._playButton.enabled = false;
        this._pauseButton.enabled = canPause;
    }

    unlock(canPause = false)
    {
        if (canPause)
        {
            return;
        }

        this._playButton.visible = !canPause;
        this._pauseButton.visible = !this._playButton.visible;

        this._playButton.enabled = true;
        this._pauseButton.enabled = true;
    }

    _onClickPlay()
    {
        this.onAction.dispatch(this, 'play');
    }

    _onClickPause()
    {
        this._playButton.visible = true;
        this._pauseButton.visible = !this._playButton.visible;
        this.onAction.dispatch(this, 'pause');
    }
}